/**
 * Debug logging utility that only logs when running in development mode
 * Uses Vite's import.meta.env.DEV to determine environment
 */

type LogLevel = 'log' | 'warn' | 'error' | 'info' | 'debug';

/**
 * Debug logger that only outputs in development mode
 * @param level - The log level (log, warn, error, info, debug)
 * @param args - Arguments to pass to the console method
 */
export const debugLog = (level: LogLevel = 'log', ...args: any[]) => {
  // Only log in development mode
  if (import.meta.env.DEV) {
    console[level](...args);
  }
};

// Convenience methods for different log levels
export const debugInfo = (...args: any[]) => debugLog('info', ...args);
export const debugWarn = (...args: any[]) => debugLog('warn', ...args);
export const debugError = (...args: any[]) => debugLog('error', ...args);
export const debugTrace = (...args: any[]) => debugLog('debug', ...args);

// Default export as debugLog for backward compatibility
export default debugLog;
